import { useState } from 'react';
import { isNullOrWhitespace } from '../../../../utils/guard';
import FormGroup from '../../../generic/FormGroup';
import HTMLInput from '../../../generic/HTMLEditor/HTMLInput';
import MessageActionsList from '../common/messageActions/MessageActionsList';
import ListenerList from '../common/listeners/ListenerList';
import NameInput from '../common/NameInput';
import OutcomeList from '../common/outcomes/OutcomeList';
import { useMapElement } from '../contextProviders/MapElementProvider';
import ModalBody from '../../../generic/modal/ModalBody';
import ModalFooter from '../../../generic/modal/ModalFooter';
import type { MapElementRequestAPI } from '../../../../sources/graph';
import Footer from '../common/Footer';

const MessageConfiguration = () => {
    const [hasSubmitted, setHasSubmitted] = useState(false);

    const {
        mapElement,
        onUpdateName,
        onUpdateComments,
        onUpdateStatusMessage,
        onUpdateNotAuthorizedMessage,
        onSaveMapElement,
        onClose,
    } = useMapElement();

    if (!mapElement) {
        onClose();
        return;
    }

    const isFormValid = !isNullOrWhitespace(mapElement?.developerName);

    const onSave = () => {
        setHasSubmitted(true);

        if (isFormValid) {
            onSaveMapElement(mapElement as MapElementRequestAPI);
            return;
        }
    };

    const renderBody = () => (
        <>
            <NameInput
                isValid={isFormValid}
                showValidation={hasSubmitted}
                id="message-name"
                name={mapElement.developerName ?? ''}
                onUpdateName={onUpdateName}
            />
            <MessageActionsList />
            <OutcomeList />
            <ListenerList />
            <h4>Feedback</h4>
            <FormGroup
                label="Message to show users that are waiting for this Message to complete"
                labelId="waitingMessage"
            >
                <HTMLInput
                    contentValue={mapElement.statusMessage ?? ''}
                    onChange={(userContent) => onUpdateStatusMessage(userContent)}
                    hasLinkPlugin={true}
                    hasImagePlugin={true}
                    hasValuePickerPlugin={true}
                    height={250}
                />
            </FormGroup>
            <FormGroup
                label="Message to show users that are not authorized to take action"
                labelId="notAuthorizedMessage"
            >
                <HTMLInput
                    contentValue={mapElement.notAuthorizedMessage ?? ''}
                    onChange={(userContent) => onUpdateNotAuthorizedMessage(userContent)}
                    hasLinkPlugin={true}
                    hasImagePlugin={true}
                    hasValuePickerPlugin={true}
                    height={250}
                />
            </FormGroup>
            <FormGroup htmlFor="message-comments" label="Comments about this Message">
                <textarea
                    id="message-comments"
                    value={mapElement.developerSummary ?? ''}
                    className="form-control form-textarea"
                    onChange={({ target: { value } }) => onUpdateComments(value)}
                />
            </FormGroup>
        </>
    );

    const renderFooter = () => {
        return <Footer save={onSave} cancel={onClose} />;
    };

    return (
        <>
            <ModalBody>{renderBody()}</ModalBody>
            <ModalFooter>{renderFooter()}</ModalFooter>
        </>
    );
};

export default MessageConfiguration;
